// @ts-strict-ignore
import { createAnimation, Animation } from '@ionic/react'

export const audioBarDefaultHeight = 90

export const containerOpen = (baseEl: HTMLElement, offset: number): Animation => {
	const wrapperAnimation = createAnimation()
		.addElement(baseEl)
		.keyframes([
			{ offset: 0, height: `${audioBarDefaultHeight + offset}px`, transform: 'translateY(100%)' },
			{ offset: 0.5, height: '50vh', transform: 'translateY(50%)' },
			{ offset: 1, height: '100dvh', transform: 'translateY(0)' },
		])
		.beforeStyles({ position: 'absolute', maxHeight: '100%' })
		.afterStyles({ 'min-height': '100dvh' })
		.duration(500)
		.easing('cubic-bezier(.165,.84,.44,1)')

	const innerAnimation = createAnimation()
		.addElement(baseEl?.querySelector('.audio-player-row'))
		.beforeStyles({ overflow: 'hidden' })
		.afterClearStyles(['overflow'])
		.fromTo('opacity', 0, 1)
		.duration(500)
		.easing('cubic-bezier(.86,0,.07,1)')
		.onFinish(() => {
			wrapperAnimation?.destroy()
			innerAnimation?.destroy()
		})

	const baseAnimation = createAnimation().addElement(baseEl).addAnimation([wrapperAnimation, innerAnimation])

	return baseAnimation
}

export const containerClose = (baseEl: HTMLElement, offset: number): Animation => {
	const wrapperAnimation = createAnimation()
		.addElement(baseEl)
		.beforeClearStyles(['min-height'])
		.beforeStyles({ position: 'absolute' })
		.keyframes(slideDownKeyframe(`calc(100dvh - ${audioBarDefaultHeight + offset}px`))
		.afterStyles({ position: 'relative', 'min-height': 'inherit' })
		.afterClearStyles(['position'])
		.duration(700)
		.easing('cubic-bezier(.165,.84,.44,1)')

	const innerAnimation = createAnimation()
		.addElement(baseEl?.querySelector('.audio-player-row'))
		.fromTo('opacity', 0, 1)
		.delay(300)
		.duration(700)
		.easing('cubic-bezier(.86,0,.07,1)')
		.onFinish(() => {
			wrapperAnimation?.destroy()
			innerAnimation?.destroy()
		})

	const baseAnimation = createAnimation().addElement(baseEl).addAnimation([wrapperAnimation, innerAnimation])

	return baseAnimation
}

/**
 * @deprecated remove before release mobile web
 */
export const containerAppear = (baseEl: HTMLElement): Animation => {
	const baseAnimation = createAnimation()
		.addElement(baseEl)
		.beforeStyles({ position: 'absolute', height: `${audioBarDefaultHeight}px` })
		.afterClearStyles(['position'])
		.fromTo('bottom', '-100%', '0')
		.duration(500)
		.easing('ease-in-out')
		.onFinish(() => baseAnimation?.destroy())

	return baseAnimation
}

export const containerDisappear = (baseEl: HTMLElement): Animation => {
	const baseAnimation = createAnimation()
		.addElement(baseEl)
		.beforeStyles({ position: 'absolute', height: 'auto' })
		.afterClearStyles(['position'])
		.afterStyles({ height: 0 })
		.keyframes(slideDownKeyframe('100%'))
		.fromTo('bottom', '0', '-100%')
		.duration(500)
		.easing('ease-in-out')

	return baseAnimation
}

const slideDownKeyframe = (finalPosition: string) => [
	{ offset: 0, height: `100dvh`, transform: 'translateY(0)' },
	{ offset: 0.5, height: '50vh', transform: 'translateY(50%)' },
	{
		offset: 1,
		height: 0,
		transform: `translateY(${finalPosition})`,
	},
]
